var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: { column: "", role: "region", "aria-label": "Dashboard content" },
    },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/dashboard-cover.png",
          height: "350",
          role: "img",
          "aria-label": "Dashbiard section banner with themed illustration",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "pb-2": "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md8: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "profile-section-card--flex-toolbar",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            "offset-xs0": "",
                            sm12: "",
                            "offset-sm0": "",
                            md10: "",
                            "offset-md1": "",
                            lg10: "",
                            "offset-lg1": "",
                            "justify-center": "",
                          },
                        },
                        [
                          _c(
                            "v-app-bar",
                            {
                              attrs: {
                                flat: "",
                                color: "secondary",
                                role: "navigation",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass: "text-body-2",
                                  attrs: { id: "profileWelcome" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("components.profile.welcome")
                                      ) +
                                      "\n                " +
                                      _vm._s(_vm.nickname) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-progress-linear", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoading,
                            expression: "isLoading",
                          },
                        ],
                        attrs: {
                          color: "accent",
                          indeterminate: "",
                          role: "progressbar",
                          "aria-label": "Loading",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-md": "" } },
                            [
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    "fixed-tabs": "",
                                    color: "accent",
                                    "show-arrows": "",
                                    centered: "",
                                    "next-icon": "fad fa-chevron-right",
                                    "prev-icon": "fad fa-chevron-left",
                                    "slider-color": "accent",
                                    role: "tablist",
                                    "aria-labelledby": "profileWelcome",
                                  },
                                },
                                [
                                  _c("v-tabs-slider"),
                                  _vm._v(" "),
                                  _vm._l(_vm.tabs, function (tab) {
                                    return _c(
                                      "v-tab",
                                      {
                                        key: tab.id,
                                        attrs: {
                                          to: tab.route,
                                          exact: "",
                                          role: "tab",
                                          "aria-label":
                                            _vm.$t("profile.tabs." + tab.id) ||
                                            tab.id,
                                          "aria-selected":
                                            _vm.$route.path === tab.route,
                                          tabindex:
                                            _vm.$route.path === tab.route
                                              ? 0
                                              : -1,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "aria-hidden": true } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(tab.icon) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "profile.tabs." + tab.id
                                              ) || tab.id
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("router-view", {
                                attrs: {
                                  username: _vm.username,
                                  email: _vm.email,
                                  "zushin-points": _vm.zushinPoints,
                                  "total-referred": _vm.totalReferred,
                                  "total-referred-completed":
                                    _vm.totalReferredCompleted,
                                  "referral-link": _vm.referralLink,
                                  role: "region",
                                  "aria-live": "polite",
                                  "aria-label": "Dashboard layout section",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }